import { NgClass, NgStyle, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbItem } from '@scalefast/core';
import { StaticFileHash } from '@scalefast/ecommerce-core';
import { ContentfulLayoutZoneBlockContent } from '../../../../core/interfaces/Contentful/LayoutZone/ContentfulLayoutZoneContent';
import { SanitizeContentfulHTMLPipe } from '../../../pipes/sanitize-contentful-html.pipe';
import { AppContentfulCategoryTitleComponent } from '../contentful-category-title/contentful-category-title/contentful-category-title.component';

@Component({
  selector: 'app-contentful-landing-page-section-body',
  templateUrl: './contentful-landing-page-section-body.component.html',
  styleUrls: ['./contentful-landing-page-section-body.component.scss'],
  imports: [NgStyle, NgClass, RouterLink, SanitizeContentfulHTMLPipe, StaticFileHash, AppContentfulCategoryTitleComponent],
  standalone: true,
})
export class AppContentfulLandingPageSectionBodyComponent implements AfterViewInit, OnDestroy {
  @Input() contentfulCategory?: ContentfulLayoutZoneBlockContent;
  @Input() articleBreadcrumbs: BreadcrumbItem | undefined;
  @Input() whiteText: boolean = false;
  @Input() aligned: 'left' | 'right' = 'left';
  @Input() index: number = 0;

  @ViewChild('disclaimerMessage', { static: false }) disclaimerMessage!: ElementRef;

  disclaimerHeight: number = 0;
  disclaimerMaxHeight: string = '100%';

  private resizeObserver: ResizeObserver | undefined;

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.resizeObserver = new ResizeObserver((entries) => {
        if (this.disclaimerHeight !== entries[0].contentRect.height + 6) {
          this.disclaimerHeight = entries[0].contentRect.height + 6;
          this.disclaimerMaxHeight = 'calc(100% - ' + this.disclaimerHeight + 'px )';
        }

        this.cdr.detectChanges();
      });

      if (this.disclaimerMessage && this.disclaimerMessage.nativeElement) {
        this.resizeObserver.observe(this.disclaimerMessage.nativeElement);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
